import { useEffect, useState } from "react";

const BASEURL = process.env.REACT_APP_BASE_URL;

interface Props {
  wwid: string;
  date: string;
  type: "cluster" | "tsp"; // add a type to switch endpoints
}

const useScannedList = ({ wwid, date, type }: Props) => {
  const [scannedList, setScannedList] = useState<any[]>([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<any>(null);

  useEffect(() => {
    let didCancel = false;
    setError(null);

    (async () => {
      try {
        setLoading(true);

        const endpoint =
          type === "cluster"
            ? "scanned-cluster"
            : "scanned-tsp";

        const response = await fetch(
          `${BASEURL}/v1/${type === "cluster" ? "clusters" : "collection"}/${endpoint}?wwid=${wwid}&date=${date}`,
          {
            headers: {
              "Content-Type": "application/json",
            },
          }
        );

        const result = await response.json();
        const data = result?.data || [];

        if (!didCancel) {
          setScannedList(data);
        }
      } catch (err) {
        if (!didCancel) setError(err);
      } finally {
        if (!didCancel) setLoading(false);
      }
    })();

    return () => {
      didCancel = true;
    };
  }, [wwid, date, type]);

  return { scannedList, loading, error };
};

export default useScannedList;
